import {
  ApiQueryConvertWorkLog,
  convertWorkLog
} from "../../../services/workLog";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_INVOICES } from "../../payments/keys";
import { QUERY_WORK_LOGS } from "../queries/useQueryWorkLogs";
import { QUERY_WORK_LOGS_SUMMARY } from "../queries/useQueryWorkLogsSummary";

export const useMutationConvertWorkLogs = () =>
  useWSMutation<
    Awaited<ReturnType<typeof convertWorkLog>>,
    WSServiceError,
    {
      workLogId: string;
      query?: ApiQueryConvertWorkLog;
    }
  >(variables => convertWorkLog(variables.workLogId, variables.query), {
    dependencies: [QUERY_WORK_LOGS, QUERY_WORK_LOGS_SUMMARY, QUERY_INVOICES]
  });
